import React from 'react';
import PropTypes from 'prop-types';
import {Card} from 'react-bootstrap/';
import {FaSwimmingPool} from "react-icons/fa";
export const Vacancy = ({vacancy}) =>{

	return(
		<>
			<Card className="text-center border-0 ">
				<Card.Header as="h1" className="bg-primary text-white">
				Vacancy
				</Card.Header>
				<Card.Body>
 	
				
				<FaSwimmingPool style={{fontSize:'6rem'}}/> 
				<b style={{fontSize:'5rem',verticalAlign:'middle'}}>
					&nbsp;{vacancy.amount === 0 ? 'Full' : vacancy.amount}
				</b>
				</Card.Body>
			</Card>
		</>
	)
}
Vacancy.propTypes = {
	vacancy: PropTypes.object
};
